//import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section id="hero" className="main-block">
       <div className="text-start content">
            <h1>Free AI digitisation scanned well logs to LAS files</h1>
            <div className="description my-3 mobile">
                Free AI-powered software to automatically digitize scanned well logs into structured digital data, saving time and eliminating manual errors.
            </div>
            <div className="description my-4 desktop">
                An AI-powered web software free to use* that automatically digitizes scanned well logs and converts them into structured, usable digital data. The system detects curves, scales, and key parameters from raster images, reducing manual digitization and minimizing interpretation errors. Designed to save time and bring legacy subsurface data back into modern geological and engineering workflows.
            </div>
       </div>
    </section>
  );
}
